import React, { createContext, useContext, useState, useEffect } from "react";
import { TRANSLATIONS } from "../lang/translations";

export type LanguageCode = "en" | "ua" | "ru";
// | 'kz'
// | 'pl'
// | 'it'
// | 'es'
// | 'de'
// | 'ar'
// | 'hi'
// | 'zh'
// | 'jp';

interface TranslationContextType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: any;
  language: LanguageCode;
  switchLanguage: (lang: LanguageCode) => void;
}

const TranslationContext = createContext<TranslationContextType | undefined>(
  undefined
);
export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const defaultLang = (localStorage.getItem("lang") as LanguageCode) || "en";
  const [language, setLanguage] = useState<LanguageCode>(defaultLang);
  const [translations, setTranslations] = useState(TRANSLATIONS[defaultLang]);

  useEffect(() => {
    localStorage.setItem("lang", language);
    setTranslations(TRANSLATIONS[language]);
  }, [language]);

  const switchLanguage = (lang: LanguageCode) => {
    if (TRANSLATIONS[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <TranslationContext.Provider
      value={{ translations, language, switchLanguage }}
    >
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error("useTranslation must be used within a TranslationProvider");
  }
  return context;
};
